import type { GetModelTreeItemsProps, ModelTreeItem } from "./model-tree.type";

import omit from "lodash/omit";

export const getModelTreeItems = ({
  nodes,
  parent,
  parentKey,
}: GetModelTreeItemsProps): ModelTreeItem[] => {
  if (!nodes?.length) return [];

  return nodes.map((node): ModelTreeItem => {
    const key = parentKey
      ? `${node.type}.${node.id}.${parentKey}`
      : `${node.type}.${node.id}`;

    return {
      key,
      data: node,
      parent,
      children: getModelTreeItems({
        nodes: node.children ?? [],
        parent: omit(node, "children"),
        parentKey: key,
      }),
    };
  });
};
